<template>
  <div class="base-head clearfix">
    <!-- <div v-if='0' class="selct-base">
      <el-select
        v-model="baseId"
        placeholder="请选择基地"
        @change="changeBase"
      >
        <el-option
          v-for="(item,index) in baseList"
          :key="index"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div> -->
    <div class="company" v-if="$route.name!=='liveMonitor'" @click="goBasicList">
      {{currentEnterprise.name}}
    </div>
    <div class="haveVideoBase" v-show="$route.name==='liveMonitor'" >
       <el-select v-model="videoBaseId" placeholder="请选择" @change="changeHaveVideoBase" class="selectas">
        <el-option
          v-for="(item,index) in haveVideoBaseList"
          :key="index"
          :label="item.value"
          :value="item.key">
        </el-option>
      </el-select>
    </div>
    <div class="title" >{{activeTitle}}</div>
    <div class="time-weather">
      <div >
        <!-- 天气定制样式  http://www.tianqi.com/dingzhi/ -->
        <iframe name="weather_inc" style="margin-top:20px;" src="//i.tianqi.com/index.php?c=code&id=10&color=white" width="240" height="25" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" ></iframe>
      </div>
      <div class="clock">
        <span>{{this.timer}}</span>
      </div>

      <div
        v-if="$route.name === 'equipmentControl'"
        class="countdown"
        @click="manualRefresh"
      >
        <span >{{count}}</span>
        <i
          class="icon icon-icon_refresh refresh"
          :class="{'set-refresh':isClick,'reflashData':this.count<100}"
        ></i>
      </div>
    </div>

  </div>
</template>

<script>
import equipmentV2 from '../../store/modules/equipmentV2'
import mixins from '@/assets/js/mixins.js'
import indexModule from '../../store/modules/index'
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
  name: 'BaseHead',
  mixins: [mixins],
  data () {
    return {
      haveVideoBaseList: [],
      videoBaseId: '',
      baseId: '',
      baseList: [
        {
          id: 154,
          name: '一号基地'
        },
        {
          id: 155,
          name: '二号基地'
        }
      ],
      timer: null,
      count: 120,
      countTimer: null,
      isClick: false
    }
  },
  watch: {
    $route (value) {
      if (value.name !== 'equipmentControl') {
        clearInterval(window.countTimer)
      } else {
        clearInterval(window.countTimer)
        this.count = 120
        let obj = JSON.parse(localStorage.getItem('currentBasic'))
        if (obj) {
          this.obj = obj
        }
        this.start()
        this.downtimer()
      }
    }
  },
  async mounted () {
    let obj = {}
    if (localStorage.getItem('currentBasic')) {
      obj = JSON.parse(localStorage.getItem('currentBasic'))
    }
    if (obj) {
      this.obj = obj
    }
    this.start()
    this.downtimer()
    let list = await this.getHaveVideoBase()
    this.haveVideoBaseList = [
      {
        key: '',
        value: '全部'
      }
    ].concat(list)
    if (this.haveVideoBaseList.length > 0) {
      this.videoBaseId = this.haveVideoBaseList[0].key
      this.setHaveVideoBaseId(this.videoBaseId)
    }
    if (this.$route.name !== 'equipmentControl') {
      clearInterval(window.countTimer)
    }
  },
  computed: {
    ...mapState(equipmentV2, ['currentEnterprise', 'activeTitle'])
  },
  methods: {
    ...mapActions(indexModule, ['getHaveVideoBase']),
    ...mapMutations(indexModule, ['setHaveVideoBaseId']),
    goBasicList () {
      if (this.$route.name === 'baseMap' || this.$route.name === 'liveMonitor') {
        return
      }
      if (this.$route.name === 'autoControl' || this.$route.name === 'timeControl' || this.$route.name === 'waterParameter' || this.$route.name === 'deviceEnergyHis') {
        this.$router.push({
          name: 'equipmentControl'
        })
        return
      }
      if (this.$route.name === 'equipmentControl') {
        this.$router.push({
          name: 'basicList'
        })
      }
    },
    changeHaveVideoBase (baseId) {
      this.setHaveVideoBaseId(baseId)
    },
    // 手动刷新
    manualRefresh () {
      let obj = JSON.parse(localStorage.getItem('currentBasic'))
      clearInterval(window.countTimer)
      this.count = 120
      this.downtimer()
      this.isClick = true
      this.getEquipmentData(obj, true).then(() => {
        this.isClick = false
      }).catch((err) => {
        this.isClick = false
        this.$Alert.info({
          content: err.response.data,
          duration: 3000,
          status: 'error'
        })
      })
    },
    // 自动刷新
    setfresh () {
      let obj = JSON.parse(localStorage.getItem('currentBasic'))
      this.isClick = true
      this.getEquipmentData(obj, false).then(() => {
        this.isClick = false
      }).catch((err) => {
        this.isClick = false
        this.$Alert.info({
          content: err.response.data,
          duration: 3000,
          status: 'error'
        })
      })
    },
    // 定时器倒数
    downtimer () {
      window.countTimer = setInterval(() => {
        --this.count
        if (this.count < 10) {
          this.count = '0' + this.count
        }
        if (parseInt(this.count) === 0) {
          this.count = 120
          this.setfresh()
        }
      }, 1000)
    },
    // 一位数补零01
    check (val) {
      if (val < 10) {
        return '0' + val
      } else {
        return val
      }
    },
    displayTime () {
      // 获取系统当前的年、月、日、小时、分钟、毫秒
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minutes = date.getMinutes()
      var second = date.getSeconds()
      this.timer =
        year +
        '年' +
        month +
        '月' +
        day +
        '日  ' +
        ' ' +
        this.check(hour) +
        ':' +
        this.check(minutes) +
        ':' +
        this.check(second)
    },
    // 每隔1秒调用一次displayTime函数
    start () {
      window.setInterval(this.displayTime, 1000) // 单位是毫秒
    }
  }
}
</script>
<style lang="scss">

.base-head {
  position: relative;
  text-align: center;
  height: 64px;
  line-height: 64px;
  padding: 0 70px 0 25px;
  background: rgba(0, 46, 115, 0.5);
  .selct-base{
    float: left;
  }
  .el-input__inner {
    border: 1px solid #0077ff;
    color: white;
    background: #203051;
  }
  > div {
    display: inline-block;
    line-height: 64px;
    color: #e0edff;
  }
  .haveVideoBase{
    position: absolute;
    left: 15px;
  }
  .company {
    position: absolute;
    left: 25px;
    font-size: 24px;
    cursor: pointer;
  }
  .title {
    display: block;
    font-size: 28px;
  }
  .time-weather {
    position: absolute;
    right: 82px;
    top: 0;
    display: flex;
    font-size: 18px;
  }
  .clock{
    margin-right:15px;
  }

  .countdown {
    position: relative;
    span,
    i {
      position: absolute;
      left: 0;
      top: 0;
    }
    span {
      left: 18px;
    }
  }

  .refresh {
    margin:12px 0 12px 12px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .reflashData{
      margin: 12px 0 0 8px;
  }
  .set-refresh {
    animation: rotate 1s infinite linear;
  }
}
</style>
